<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator'

    @Component
    export class RateNote extends Vue {
        @Prop({required: true}) room

        render() {
            return null
        }
    }

    export default RateNote
</script>
